#card-wrapper {
  border: 1px solid var(--chart-101-pressed-dividers);
  border-radius: 4px;
  width: fit-content;
  padding: calc(var(--spacer) + 6px) 0 calc(var(--spacer) * 2 - 3px);
  min-width: calc(22 * var(--spacer));
  text-align: center;
  white-space: nowrap;

  gz-text {
    width: fit-content;
  }

  .main-text {
    width: auto;
    padding: 0 calc(2 * var(--spacer));
  }
}

.gray-txt {
  color: var(--chart-300-icon-buttons);
}

#card-wrapper.error-card-wrapper {
  border-color: var(--red-layout-300-primary);
}
